import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./AuthorLink.css";

export default function AuthorLink({ username, children, ...props }) {
  return (
    <Link to={`/authors/${username}`} className={classNames(styles.root, "gtm-author-byline")} {...props}>
      {children}
    </Link>
  );
}

AuthorLink.propTypes = {
  username: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
